module.exports = __webpack_public_path__ + "media/images/icons/outlined/meh-59b6c82029c6cadaf8d09fa69e78e84e.svg";